/** Son à l’envoi — fixe (pas de choix utilisateur). */

export const CHAT_SEND_POP_FILE = "Sweet UI Open.wav";

export const CHAT_SEND_POP_LABEL = "Sweet UI Open";

export function chatSendPopSoundUrl(file: string = CHAT_SEND_POP_FILE): string {
  return `./sound/${encodeURIComponent(file)}`;
}
